"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokenize_1 = require("./tokenize");
/**
 * Kebab case the given string.
 *
 * @Param {string} text = The text to kebab case.
 *
 * @Example
 *
 *   kebabCase('SCREAM_CASE')
 *   //=> 'scream-case'
 *
 *   kebabCase('camelCase')
 *   //=> 'camel-case'
 *
 *   kebabCase('snake_case')
 *   //=> 'snake-case'
 */
function kebabCase(text) {
    return tokenize_1.tokenize(text)
        .map((token) => token.toLowerCase())
        .join("-");
}
exports.kebabCase = kebabCase;
//# sourceMappingURL=kebab-case.js.map